import React from 'react';

import { useCacheAndProcessOrdersMutation } from 'generated/graphql';
import { DateTime } from 'luxon';



export function useCacheAndProcessOrders(storeId: string) {
  const [fnMutate, tuple] = useCacheAndProcessOrdersMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (startTime: DateTime | null, orderId: string) => {
      await fnMutate({
        variables: {
          storeId,
          startTime: startTime && startTime.toISO() as string,
          orderId
        }
      });
    },
    [
      fnMutate,
      storeId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
